<template>
    <div class="installt">
        <div class="intext">会员礼包</div>
        <div class="addpopers">

            <div class="addpoper" @click="openDialog">
                <div> <el-icon :size="24" color="#fff">
                        <Plus style=" margin-right: 8px" />
                    </el-icon></div>
                <div style="height: 24px;">添加礼包</div>

            </div>
        </div>

    </div>
    <div class="goody" v-loading="loading">
        <Noshu :disabled="loading" :lengths="StoreDatalist.length"></Noshu>

        <div class="vipt">
            <div class="screen">
                <el-cascader v-model="valuezhuan" :options="options" placeholder="状态选择:" @change="handleChange" />
            </div>
            <div class="search">
                <div style="width: 24px;height: 24px;text-align: center;">
                    <img style="width: 100%;height: 100%;" src="../../assets/secree.png" alt="">
                </div>
                <div>
                    <input type="text" placeholder="关键词搜索" v-model="keyword" @keyup.enter="wordkey">
                </div>
            </div>
          
        </div>

        <table>
            <thead>

                <tr>
                    <th style="width: 275px;">礼包名称</th>
                    <th>礼包内容</th>
                    <th style="width: 80px;">礼包价值</th>

                    <th>库存</th>
                    <th>状态</th>
                    <th style="width: 130px;">操作</th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="item in StoreDatalist">
                    <td>

                        <div class="goodyname">
                            <p> {{ item.name }} </p>
                        </div>

                    </td>
                    <td style=" vertical-align: top;">
                        <div class="libaonei">
                            <div class="libaoneis" v-for="(item2, index) in item.newgoodlist"
                                v-if="item.newgoodlist.length < 3">
                                <div class="mmimg">
                                    <img :src="images(item2.pic)">
                                </div>
                                <div class="libaomms">
                                    <div class="imgname">{{ item2.name }}</div>
                                    <div class="imngnub">数量：{{ item2.lpNums }}</div>
                                </div>
                            </div>
                            <div class="libaoneis" v-for="(item2, index) in item.newgoodlist" v-else>
                                <div style="display: flex;align-items: center;">
                                    <div class="mmimg2">
                                        <img :src="images(item2.pic)">
                                    </div>
                                    <div class="libaomms2">
                                        <div class="imgname" style="" :title="item2.name"> {{ item2.name }} </div>
                                        <div class="imngnub2">*{{ item2.lpNums || 0 }}</div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </td>
                    <td class="ymoney">
                        ¥{{ item.price }} &nbsp; <el-icon style="cursor: pointer;" color="#0F97FF"
                            @click="ymonyc(item.id, item.name, item.price, '1')">
                            <EditPen />
                        </el-icon>
                    </td>

                    <td>

                        <el-input-number v-model="item.stockCount" :min="0" :max="999999" controls-position="right"
                            @blur="inpnumber(item)" @change="inpnumber(item)" />
                    </td>
                    <th>
                        <div class='state'> {{ goodystate(item.state) }} </div>
                    </th>

                    <td class="gongnen">
                        <div style="width: 130px;">
                            <div class="bianjili">
                                <div class="gongnens" @click="tomsg(item)">编辑礼包</div>
                                <div class="gongnens" @click="shangjia(item)"  > {{ item.state == 1 ? '下架礼包' : '上架礼包' }} </div>

                            </div>
                            <div class="bianjili">
                                <div class="gongnens" @click="ymonyc(item.id, item.name, item.price, '2')">编辑名称</div>
                                <div class="gongnens" @click="removeGift(item.id)">删除礼包</div>
                            </div>

                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div style=" height: 70px;"></div>
        <div class="pagechoose">

            显示结果：

            <div class="pagees">

                <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

            </div>

        </div>
        <div v-if="keyseache.length >= 1">
            <el-pagination :disabled="loading" class="example-pagination-iskey" background
                v-model:current-page="current" layout="prev, pager, next" :pager-count="5" :page-count="9999999"
                @current-change="changepige" />
        </div>
        <div class="example-pagination-block" v-else>
            <el-pagination :disabled="loading" background v-model:current-page="current" :page-size='pageSize'
                layout="prev, pager, next" :pager-count="5" :total="total" @current-change="changepige" />
        </div>
    </div>

    <Mask ref="maskRef" :close-on-click-modal="false">
        <div class="addmy">
            <div style="padding: 27px 20px 0 36px;">
                <div class="dialogt">
                    <div>
                        添加礼包
                    </div>
                    <div @click="closeDialog">
                        <el-icon>
                            <Close />
                        </el-icon>
                    </div>
                </div>
                <div class="libaoname">
                    <div>礼包名称</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入礼包名称" v-model="giftName">
                    </div>

                </div>
                <div class="libaoname">
                    <div>礼包价格（¥）</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入礼包价格" v-model="giftPrice">
                    </div>

                </div>
                <div class="libaoname">
                    <div>库存</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入礼包库存" v-model="giftku">
                    </div>

                </div>
            </div>

            <div class="islibao">
                <div class="quxiao" @click="closeDialog"> 取消 </div>
                <div class="quxiao queren" @click="addGift"> 保存 </div>

            </div>
        </div>
    </Mask>

</template>

<script setup>
import { onMounted, ref,reactive  } from 'vue'
import Mask from '@/components/mask/mask.vue';
import { useRouter } from 'vue-router'
import storeapi from '@/api/store';
import { ElMessage, ElMessageBox } from 'element-plus'
import Noshu from '@/components/Noshu.vue'

import images from '@/utils/images';
const router = useRouter()
let loading = ref(false)
let current = ref(1)
let keyword = ref('')
let startDate = ref('')
let endDate = ref('')
let StoreDatalist = ref([])
let valuezhuan = ref(1)
let total = ref(100)
let keywordType = ref(1)
let pageSize = ref(6)
let keyseache = ref('')

let giftName = ref('')

let giftPrice = ref('')
let giftku = ref(0)
let storeId = ref(77)

onMounted(() => {
    goodylist()
})

const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    goodylist()
}
const removeGift = (id) => {
    ElMessageBox.confirm(
        '是否删除该礼包?',
        'Warning',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            shanchu(id)
        })
        .catch(() => {

        })
}
const shangjia = (item) =>{
    let shelfStatus =  item.state == 1 ? '是否下架礼包？' : '是否上架礼包？'
    ElMessageBox.confirm(
        shelfStatus,
        'Warning',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            statachange(item)
        })
        .catch(() => {

        })
}
const statachange = async(item) =>{

    let shelfStatus =  item.state == 1 ? 0 : 1
    let data = {
        giftId: item.id,
        shelfStatus
    }
    const res = await storeapi.alterGift(data)
    if (res.success) {
        ElMessage({
            message: '修改成功.',
            type: 'success',
            duration: '1500',
            onClose: () => {

                goodylist()
            }
        })
    } else {
        ElMessage.error(res.message)
    }

}
const wordkey = () => {
    
    current.value = 1
    

    goodylist()
}
const ymonyc = (id, name, price, isv) => {
    let msg
    let inputPattern
    let inputErrorMessage
    if (isv == 1) {
        msg = '请输入价格'
        inputPattern = /^\d+$/
        inputErrorMessage = '请输入正确的价格数字'
    } else {
        msg = '请输入名称'
        inputPattern = /.+/
        inputErrorMessage = '请输入至少一个字'

    }
    ElMessageBox.prompt(msg, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: inputPattern,
        inputErrorMessage: inputErrorMessage,
    })
        .then(({ value }) => {

            let name2 = name
            let price2 = price
            if (isv == 1) {
                price2 = value
            } else {
                name2 = value
            }
            console.log(id, name2, price2)
            alterGift(id, name2, price2)


        })
        .catch(() => {

        })
}

const alterGift = async (id, name, price) => {
    let data = {
        giftId: id,
        giftPrice: price,
        giftName: name
    }
    const res = await storeapi.alterGift(data)
    if (res.success) {
        ElMessage({
            message: '修改成功.',
            type: 'success',
            duration: '1500',
            onClose: () => {

                goodylist()
            }
        })
    } else {
        ElMessage.error(res.message)
    }
}


const shanchu = async (id) => {
    let data = {
        giftId: id
    }
    const res = await storeapi.removeGift(data)
    if (res.success) {
        ElMessage({
            message: '删除礼包成功.',
            type: 'success',
            duration: '1500',
            onClose: () => {
                // openDialog()
                goodylist()
            }
        })
    } else {
        ElMessage.error(res.message)
    }
}

const inpnumber = async(item) => {
   console.log(item)
   let data = {
        giftId: item.id,
        stockCount:item.stockCount,
        isAddProductStockCount:1

    }
    const res = await storeapi.alterGift(data)
    if (res.success) {
        // ElMessage({
        //     message: '修改成功.',
        //     type: 'success',
        //     duration: '1500',
        //     // onClose: () => {

        //     //     goodylist()
        //     // }
        // })
    } else {
        ElMessage.error(res.message)
    }
}

const addGift = async () => {
    let data = {
        giftName: giftName.value,
        giftPrice: giftPrice.value,
        storeId: storeId.value
    }
    const res = await storeapi.addGift(data)
    console.log(res, data)
    if (res.success) {
        ElMessage({
            message: '添加礼包成功.',
            type: 'success',
            duration: '1500',
            onClose: () => {
                closeDialog()
                goodylist()
            }
        })
    } else {
        ElMessage.error(res.message)
    }
}
const options = reactive([
    {
        value: '1',
        label: '已上架商品',
    },
    {
        value: '0',
        label: '已下架商品',
    }
])

const handleChange = (value) => {
    console.log(value)
    valuezhuan.value = value[0]
    // keyword.value = ''
    current.value = 1
    goodylist()
}
const goodylist = async () => {
    loading.value = true
    try {
        let data = {

                "endDate": endDate.value,
                "keyword": keyword.value,
                // 'orderStatus':orderStatus.value,

                'keywordType': keywordType.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                },
                "startDate": startDate.value
            }
        

        const res = await storeapi.pageGift(data,valuezhuan.value)
        if (res.success) {

            // lpProductList
            // productList
            let agoodlist = res.data.records

            for (let a = 0; a < agoodlist.length; a++) {

                if (agoodlist[a].stockCount) {
                    agoodlist[a].stockCount = agoodlist[a].stockCount
                } else {
                    agoodlist[a].stockCount = 0
                }



                if (agoodlist[a].lpId.length >= 1) {
                    for (let b = 0; b < agoodlist[a].lpId.length; b++) {
                        agoodlist[a].lpProductList[b].lpId = agoodlist[a].lpId[b]
                        agoodlist[a].lpProductList[b].lpNums = agoodlist[a].lpNums[b]



                    }
                }
                if (agoodlist[a].pid.length >= 1) {
                    console.log('a', a, agoodlist[a])
                    for (let b = 0; b < agoodlist[a].pid.length; b++) {
                        agoodlist[a].productList[b].lpId = agoodlist[a].pid[b]
                        agoodlist[a].productList[b].lpNums = agoodlist[a].pnums[b]

                    }
                }
            }

            console.log('agoodlist', agoodlist)

            for (let a = 0; a < agoodlist.length; a++) {



                if (agoodlist[a].productList) {
                    let productList = agoodlist[a].productList
                    let productLists = []
                    for (let b = 0; b < productList.length; b++) {
                        if (productList[b] !== null) {
                            let data = {
                                name: productList[b].pname,
                                pic: productList[b].ppreviewpic,
                                price: productList[b].pprice,
                                state: '',
                                storeId: productList[b].pcomid,
                                lpId: productList[b].lpId,
                                lpNums: productList[b].lpNums,
                                productType: 1
                            }
                            productLists.push(data)
                        }
                    }
                    console.log('productLists', productLists)
                    agoodlist[a].productLists = productLists

                }
                if (agoodlist[a].lpProductList) {
                    for (let b = 0; b < agoodlist[a].lpProductList.length; b++) {
                        agoodlist[a].lpProductList[b].productType = 2
                    }

                }

            }


            for (let a = 0; a < agoodlist.length; a++) {

                let lpProductList = agoodlist[a].lpProductList || []




                let productList = agoodlist[a].productLists || []
                // if (productList.length >= 1) {
                //     for (let b = 0; b < productList.length; b++) {
                //         agoodlist[b].productType = 1
                //     }
                // }



                let goodlist = [...lpProductList, ...productList];
                let newgoodlist
                if (goodlist.length >= 4) {
                    newgoodlist = [...goodlist.slice(0, 4)];

                } else {
                    newgoodlist = [...goodlist]
                }
                agoodlist[a].goodlist = goodlist;
                agoodlist[a].newgoodlist = newgoodlist;

            }
            StoreDatalist.value = agoodlist

            total.value = res.data.total
            console.log('total.value', total.value)

            loading.value = false
            console.log('交易订单', StoreDatalist.value, total.value)

        } else {

        }

    } catch (error) {
        // 处理错误
        console.log(error)
    }
}

const goodystate = (state) => {
    if (state == 1) {
        return '已上架'
    } else if (state == 0) {
        return '已下架'

    } else {
        return '未知状态'

    }
}

const tomsg = (item) => {
    sessionStorage.setItem('goody', JSON.stringify(item))
    router.push({
        path: '/home/goody/goodymsg'
    })
}
const changepige = (val) => {
    console.log(val)
    current.val = val
    goodylist()
}
//获取遮罩的实例
let maskRef = ref(null);
//打开弹窗
let openDialog = () => {
    maskRef.value.showMask();
};

//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};


</script>

<style lang="scss" scoped>

::v-deep .el-input--suffix {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }

}

::v-deep .el-pagination {
    position: absolute;
    bottom: 15px;
    right: 34px;


    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }

}

::v-deep .example-pagination-iskey {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .el-pager {
        display: none !important;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }
}

::v-deep .el-input-number {
    width: 88px;
    height: 32px;
}

.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 32px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpopers {
        display: flex;

        .addpoper {
            width: 132px;
            height: 48px;
            background: rgba(63, 140, 255);
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            border-radius: 8px;
            color: #FFFFFF;

            padding-left: 16px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-left: 33px;
            cursor: pointer;
        }
    }

}

.goody {
    position: relative;
    margin-top: 22px;
    height: calc(100% - 50px - 32px);
    background-color: #fff;
    border-radius: 8px;
    min-width: 1120px;
    .vipt {
        padding-top: 17px;
        margin-left: 15px;
        display: flex;

        .screen {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;
            margin-right: 24px;
        }

        .search {
            width: 412px;
            height: 48px;
            margin-right: 14px;
            background: #FAFAFA;
            // box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
            border-radius: 8px;
            display: flex;
            align-items: center;
            padding-left: 20px;
            box-sizing: border-box;

            input {
                width: 300px;
                border: none;
                outline: none;
                font-size: 16px;
                background: #FAFAFA;

            }

            ::placeholder {
                font-weight: 400;
                font-size: 14px;
                color: #7D8592;
            }

        }

        .calendar {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;



        }

        .exdown {
            width: 101px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;
            margin-left: 31px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #718096;
            cursor: pointer;


            img {
                width: 17px;
                height: 21px;
            }
        }

    }
    .pagechoose {
        position: absolute;
        bottom: 0px;
        left: 14px;
        width: 100%;
        height: 70px;
        padding-left: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .pagees {
            width: 71px;
            height: 40px;
            border: 1px solid #EEEFF2;
            border-radius: 8px;
            padding: 8px 0 0 0px;
            box-sizing: border-box;

            input {
                width: 80%;


            }
        }
    }

    table {
        width: 100%;
        border-collapse: collapse;


        thead {
            height: 48px;
            width: 100%;

            tr {


                th {
                    line-height: 48px;
                    border-bottom: 1px solid #EEEFF2;
                    font-size: 14px;
                    color: #4D585F;
                    text-align: left;

                }

                :nth-child(1) {
                    padding-left: 20px;
                    box-sizing: border-box;
                }
            }
        }

        tbody {
            tr {
                height: 96px;
                background: #fff;
                border-bottom: 1px solid #EEEFF2;

                .goodyname {
                    width: 270px;
                    height: 96px;
                    display: flex;
                    align-items: center;
                    line-height: 20px;
                    // line-height: 96px;




                    font-size: 16px;
                    color: #111827;
                    padding-left: 20px;
                    box-sizing: border-box;

                    p {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        /* 显示的行数 */
                        -webkit-box-orient: vertical;
                        white-space: normal;
                    }


                }

                .libaonei {
                    display: flex;
                    height: 96px;
                    flex-wrap: wrap;
                    width: 460px;

                    .libaoneis {
                        width: 50%;
                        display: flex;
                        align-items: center;
                        // height: 101px;

                        .mmimg {
                            width: 56px;
                            height: 56px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .mmimg2 {
                            width: 28px;
                            height: 28px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .libaomms {
                            height: 46px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            margin-left: 10px;

                            .imgname {
                                width: 150px;
                                text-overflow: ellipsis;
                                /*省略号 */
                                white-space: nowrap;
                                /*溢出时不换行 */
                                overflow: hidden;
                                /*溢出时隐藏 */
                                font-size: 16px;
                                color: #111827;
                                line-height: 18px;

                            }

                            .imngnub {
                                font-size: 14px;
                                color: #718096;
                                line-height: 18px;

                            }

                            .imngnub2 {
                                font-size: 14px;
                                color: #718096;
                            }
                        }

                        .libaomms2 {


                            margin-left: 10px;
                            display: flex;
                            align-items: center;

                            .imgname {
                                width: 150px;
                                text-overflow: ellipsis;
                                /*省略号 */
                                white-space: nowrap;
                                /*溢出时不换行 */
                                overflow: hidden;
                                /*溢出时隐藏 */

                                font-size: 16px;
                                color: #111827;


                            }

                            .imngnub2 {
                                font-size: 14px;
                                color: #718096;
                            }



                        }
                    }
                }

                .ymoney {
                    font-size: 14px;
                    color: #718096;
                }

                .state {
                    width: 66px;
                    height: 41px;
                    background: #EBF3FF;
                    border-radius: 8px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #1787FF;
                    text-align: center;
                    line-height: 41px;
                    margin: 0 10px;
                }

                .gongnen {
                    font-size: 14px;
                    color: #0091FF;
                    padding-right: 20px;
                    vertical-align: middle;
                    margin-left: 20px;

                    // height: 100%;
                    // box-sizing: border-box;
                    .bianjili {
                        display: flex;
                        justify-content: space-between;
                        // height: 90px;

                        .gongnens {
                            line-height: 25px;
                            cursor: pointer;
                        }
                    }

                }

            }

            :hover {
                background: #F9FAFB;

            }
        }
    }

}

.addmy {
    width: 465px;
    // height: 443px;
    background: #FFFFFF;
    border-radius: 8px;
    border-radius: 8px;

    font-size: 16px;
    color: #111827;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;

    }


    .libaoname {
        margin-top: 27px;
        margin-left: 10px;

        .liname {
            width: 391px;
            height: 56px;
            background: #FAFAFA;
            margin-top: 16px;

            input {
                height: 56px;

            }
        }
    }

    .islibao {
        width: 100%;
        height: 101px;
        border-top: 1px solid #EEEFF2;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-top: 55px;

        .quxiao {
            width: 108px;
            height: 48px;
            border: 1px solid #979797;
            text-align: center;
            line-height: 48px;
            border-radius: 8px;
            cursor: pointer;

        }

        .queren {
            background: #79AFFF;
            color: #FFFFFF;
            border: 1px solid transparent;

        }
    }
}
</style>